import CreateInvestStrategyForm from './CreateInvestStrategyForm';

export default CreateInvestStrategyForm;
